<div class="content">
  @if(!!iconName()){
    <span class="icon-circle">
      <lib-icon [name]="iconName()" [height]="'1.75rem'" [width]="'1.75rem'"></lib-icon>
    </span>
  }
  
  <div>
    <span class="heading"><span class="new">New</span><ng-content select="[heading]"></ng-content></span>
    <span class="subheading"><ng-content select="[subheading]"></ng-content></span>
  </div>
</div>

<ng-content select="[button-slot]"></ng-content>